<template>
  <v-app>
    <div class="spinner">
      <v-progress-circular indeterminate
                           size="70"
                           color="green"/>
    </div>

    <template v-if="!user">
      <v-app-bar app color="#9c7438" dark>
        <div class="d-flex align-center">
          <v-img alt="Vuetify Logo"
                 class="shrink mr-2"
                 contain
                 src="./assets/ole.png"
                 transition="scale-transition"
                 width="40"/>
        </div>
        <div class="d-flex align-center" style="font-size: 14px">
          Olè Natural Medical Skin
        </div>
        <v-spacer></v-spacer>
        <v-btn @click="dialog=true"
               target="_blank"
               text>
          <span class="mr-2">立即試做</span>
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>

        <!--				<v-btn @click="logout()">logout</v-btn>-->
      </v-app-bar>

      <v-content>
        <HelloWorld @openDialog="dialog=true"/>
      </v-content>

      <v-row justify="center">
        <v-dialog v-model="dialog" max-width="600px">
          <applyToken/>
        </v-dialog>
      </v-row>
    </template>

    <displayToken v-else/>
  </v-app>
</template>

<script>
import HelloWorld               from './components/HelloWorld'
import applyToken               from './components/applyToken'
import displayToken             from './components/displayToken'
import firebase                 from './firebase'
import {mapState, mapMutations} from 'vuex'
import $                        from 'jquery'

export default {
  name     : 'App',
  computed : {
    ...mapState(['user'])
  },
  watch    : {},
  created () {
    $('body').addClass('busy')
    let t = this
    firebase.auth().onAuthStateChanged(function (user) {
      if (user && user.phoneNumber && !t.user) {
        console.log('in')
        let db = firebase.firestore()
        let userDoc = db.collection('trials').doc(user.phoneNumber)
        userDoc.get().then(function (doc) {
          if (doc.exists && doc.data().token) {
            // console.log('setUser in page refresh')
            t.setUser({
              ...doc.data(),
            })
          } else {
            // doc.data() will be undefined in this case
            // console.log("No such document!")
          }

          $('body').removeClass('busy')
        }).catch(function (error) {
          $('body').removeClass('busy')
          // console.log("Error getting document:", error)
        })
        // User is signed in.
      } else {
        // console.log('no user')
        $('body').removeClass('busy')
        // No user is signed in.
      }
    })
  },
  methods    : {
    ...mapMutations(['setUser']),
    logout () {
      firebase.auth().signOut().then(function () {
        // Sign-out successful.
      }).catch(function (error) {
        // An error happened.
      });
    }
  },
  components : {
    HelloWorld,
    applyToken,
    displayToken,
  },

  data : () => ({
    //
    dialog : false,
  }),
}
</script>
<style lang="less">
#app {
  max-width: 100%;
  overflow: hidden;
}

.busy {
  .spinner {
    display: flex !important;
  }
}

.spinner {
  display: none;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
}
</style>
